import React from "react";
import styled from "styled-components";
import Button from "~/components/styled/Button";
import TextWithArrow from "./TextWithArrow";

const SubMenuButton = styled(Button)`
  display: flex;
  width: auto;
  justify-content: flex-end;
  width: 100%;
  align-items: center;
  color: #000;
`;

export const SubMenuToggle = ({
  label,
  controlsId,
  isExpanded,
  onClick,
}: {
  label: string;
  controlsId: string;
  isExpanded: boolean;
  onClick: Function;
}) => {
  return (
    <SubMenuButton
      onClick={() => {
        if (typeof onClick === "function") onClick.call(null);
      }}
      aria-expanded={isExpanded}
      aria-label={`${isExpanded ? "close" : "open"} ${label}`}
      aria-controls={controlsId}
    >
      <TextWithArrow
        icon="triangle"
        align={isExpanded ? "up" : "down"}
        heading="h4"
        size={9}
        sizeCorrector={1}
        tuckUp={0}
      >
        {label}
      </TextWithArrow>
    </SubMenuButton>
  );
};
